import { connect } from "react-redux";

import { IUser } from "@common/models";
import AdminUser, { IAdminUserProps, IAdminUserActions } from "./admin-user";
import { navigateTo } from "../../home";

export default connect(
  ({ admin }: any, { match }: any): IAdminUserProps => {
    const {
      params: { id }
    } = match;
    const { users } = admin;
    const user = users.filter((u: IUser) => u.userId === id)[0];
    return { user };
  },
  (dispatch): IAdminUserActions => {
    return { navigateBack: () => dispatch(navigateTo("/admin/user")) };
  }
)(AdminUser);
